import { CUSTOM_MESSAGE_SRC } from "../constant";
import TUIChatEngine, { TUIStore, StoreName, TUIChatService } from "../@aidesk/uikit-engine";

let heartbeatTimer: ReturnType<typeof setTimeout> | null = null;
let isHeartbeatRunning = false;
let currentConversationID = TUIStore.getData(StoreName.CONV, 'currentConversationID');
const HEARTBEAT_INTERVAL = 30000; // 30 秒

// 在人工排队时发送心跳
export async function sendHeartbeat(conversationID: string, eventName: string) {
  await TUIChatService.sendCustomMessage({
    to: conversationID.slice(3),
    conversationType: TUIChatEngine.TYPES.CONV_C2C,
    payload: {
      data: JSON.stringify({
        customerServicePlugin: 0,
        src: CUSTOM_MESSAGE_SRC.SEND_HEARTBEAT,
        userClientEvent: {
          event: eventName,
        },
      }),
    },
    needReadReceipt: false,
  },{ onlineUserOnly: true });
}

function canSendHeartbeat() {
  const isQueuing = TUIStore.getData(StoreName.CUSTOM, 'isQueuing');
  const queueLeavePageTimeoutEnable = TUIStore.getData(StoreName.CUSTOM, 'queueLeavePageTimeoutEnable');
  currentConversationID = TUIStore.getData(StoreName.CONV, 'currentConversationID');
  const queueNumber = isQueuing && isQueuing.conversationID === currentConversationID ? isQueuing.value : -1;
  if (queueNumber < 0 || !queueLeavePageTimeoutEnable || !currentConversationID) {
    return false;
  }
  return true;
}

export function startHeartbeat() {
  if (!canSendHeartbeat() || isHeartbeatRunning) {
    stopHeartbeat();
    return;
  }

  isHeartbeatRunning = true;
  (async function loop() {
    if (!canSendHeartbeat() || !isHeartbeatRunning) {
      stopHeartbeat();
      return;
    }
    await sendHeartbeat(currentConversationID, "sessionPageHeartbeat");

    heartbeatTimer = setTimeout(() => {
      heartbeatTimer = null;
      loop();
    }, HEARTBEAT_INTERVAL);
  })();
}

export function stopHeartbeat() {
  if (heartbeatTimer !== null) {
    clearTimeout(heartbeatTimer!);
    heartbeatTimer = null;
  }
  isHeartbeatRunning = false; 
}